"use strict";

import { VOICE_REDO_JOBS } from "../../ApiEndpoints.js";
import {
  getWithFirebaseAuth,
  postWithFirebaseAuth,
} from "../../utils/firebaseApiClient.js";

// Redoing all of a character's lines with a new voice runs on the server; these
// calls start, follow and stop a run. A run's id is "<language>__<speaker>".

const jobsUrl = (projectId) =>
  `${VOICE_REDO_JOBS}/${encodeURIComponent(projectId)}/voice-redo-jobs`;

export const ACTIVE_REDO_STATUSES = new Set(["queued", "inProgress"]);

export const isRedoJobActive = (job) => ACTIVE_REDO_STATUSES.has(job?.status);

/** How many of the character's lines a run would redo. */
export const countRedoLines = async ({
  projectId,
  languageCode,
  speakerId,
}) => {
  const response = await postWithFirebaseAuth(`${jobsUrl(projectId)}/count`, {
    languageCode,
    speakerId,
  });
  return response.data?.total ?? 0;
};

/** Starts a run; `dialogueIds` limits it, e.g. to retry failed lines. */
export const startRedoJob = async ({
  projectId,
  languageCode,
  speakerId,
  voiceId,
  dialogueIds,
}) => {
  const response = await postWithFirebaseAuth(jobsUrl(projectId), {
    languageCode,
    speakerId,
    voiceId,
    ...(dialogueIds ? { dialogueIds } : {}),
  });
  return response.data.job;
};

/** The project's runs in one language. */
export const listRedoJobs = async ({ projectId, languageCode }) => {
  const response = await getWithFirebaseAuth(jobsUrl(projectId), {
    params: { languageCode },
  });
  return response.data?.jobs || [];
};

/** Asks a run to stop; lines already redone keep their new takes. */
export const stopRedoJob = async ({ projectId, jobId }) => {
  const response = await postWithFirebaseAuth(
    `${jobsUrl(projectId)}/${encodeURIComponent(jobId)}/cancel`,
    {}
  );
  return response.data.job;
};
